import React from "react"

const Accessories = () => {

    return (
        <div className="container">

        </div>
    )
}

export default Accessories;